import { trackEcommerceEvent } from "utils/helpers/analytics";
import customAxiosInterceptor from "../customAxiosInterceptor";

export const newOrderThunk = async (data, thunkAPI) => {
  try {
    const response = await customAxiosInterceptor.post("/order", data);
    let purchaseData = {
      transaction_id: response.data.data.id,
      value: response.data.data.total_price_discount,
      shipping: response.data.data.delivery_cost,
      currency: "BAM",
      items: response.data.data.order_items.map((item) => ({
        item_id: item.sku,
        item_name: item.article_name,
        discount: parseFloat(item.discount),
        price: item.discount_price,
        quantity: item.amount,
      })),
    };
    trackEcommerceEvent("purchase", purchaseData);
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};
//https://infocomp.ba/api/config-param?name=minimalan_iznos_za_besplatnu_dostavu
export const getConfigParamThunk = async (thunkAPI) => {
  try {
    const response = await customAxiosInterceptor.get(
      "/config-param?name=minimalan_iznos_za_besplatnu_dostavu"
    );
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};

//https://infocomp.ba/api/courier
export const getCourierThunk = async (thunkAPI) => {
  try {
    const response = await customAxiosInterceptor.get("/courier");
    return response.data.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data.msg);
  }
};
